import { createDirectus, rest, authentication } from "@directus/sdk";
import { API_URL } from "./constants";

export const directus = createDirectus(API_URL)
  .with(rest())
  .with(
    authentication("json", { autoRefresh: true, msRefreshBeforeExpires: 30000 })
  );
